// extracted by mini-css-extract-plugin
module.exports = {"filters":"_1kjLPmSj0q7TtHVNrfRJ1m","filterLabel":"_2eLpAbcJXOo1hyK7N0hjmw","filterLabelIcon":"XyGEsurensAh9f9rXazCb"};